import React from "react";

import { Grid, Typography } from "@mui/material";
import { useLocation } from "react-router-dom";

//import { setDLData, setAadharData } from "../../redux/slices/documentSlice";
import VideoPreview from "./Preview";

export default function PreviewVideo() {
  const userData = useLocation();

  //   useEffect(() => {
  //     if (userData.state.userData) {
  //       if (userData.state.userData.identityType === "dl") {
  //         dispatch(setDLData(userData.state.userData));
  //       }
  //       if (userData.state.userData.identityType === "aadhaar") {
  //         dispatch(setAadharData(userData.state.userData));
  //       }
  //     }
  //   }, [dispatch, userData.state.userData]);

  return (
    <React.Fragment>
      <VideoPreview userData={userData} />
    </React.Fragment>
  );
}
